import { toPercent } from '@/common/js/filters'

export default function (data) {
  const { prev, next } = data
  if (prev.name.includes('率') || prev.name.includes('留存') || prev.name.includes('ROI')) {
    console.log(prev)
    prev.name = prev.name.concat('(%)')
    prev.list = prev.list.map(item => {
      const v = toPercent(item.value).slice(0, -1)
      item.value = v
      return item
    })
  }
  if (next.name.includes('率') || next.name.includes('留存') || next.name.includes('ROI')) {
    next.name = next.name.concat('(%)')
    next.list = next.list.map(item => {
      const v = toPercent(item.value).slice(0, -1)
      return parseFloat(v)
    })
  }

  return {
    title: {
      text: '',
      textStyle: {
        align: 'center',
        color: '#000',
        fontSize: 20
      },
      top: '3%',
      left: '10%'
    },
    backgroundColor: '#ffffff',
    grid: {
      top: '15%',
      bottom: '10%',
      left: '5%',
      right: '5%'
    },
    tooltip: {
      trigger: 'axis'
      // formatter: '{a}:{b}:{c}'
      // axisPointer: {
      //   type: 'shadow',
      //   label: {
      //     show: true
      //   }
      // }
    },
    legend: {
      data: [prev.name, next.name],
      top: '10%',
      textStyle: {
        color: '#333'
      }
    },
    xAxis: {
      boundaryGap: false,
      data: prev.list.map(d => d.tdate),
      axisLine: {
        show: true, // 隐藏X轴轴线
        lineStyle: {
          // color: 'red'
        }
      },
      axisTick: {
        show: true,
        // interval: 0 // 可以设置成 0 强制显示所有标签， 如果设置为 1，表示隔一个标签显示一个标签
        lineStyle: {
          opacity: 0.8
        }

      },
      axisLabel: {
        show: true,
        textStyle: {
          color: '#333'
        }
      }

    },
    yAxis: [
      {
        type: 'value',
        name: prev.name,
        nameTextStyle: {
          color: '#333'
        },
        splitLine: {
          show: true,
          lineStyle: {
            type: 'dashed',
            opacity: 0.5
          }
        },
        axisTick: {
          show: true
        },
        axisLine: {
          show: true,
          lineStyle: {
            color: '#333'
          }
        },
        axisLabel: {
          show: true,
          textStyle: {
            color: '#333'
          }
        }

      },
      {
        type: 'value',
        name: next.name,
        nameTextStyle: {
          color: '#333'
        },
        position: 'right',
        splitLine: {
          show: false
        },
        axisTick: {
          show: true
        },
        axisLine: {
          show: true
        },
        axisLabel: {
          show: true,
          textStyle: {
            color: '#333'
          }
        }
      }
    ],
    series: [
      {
        name: prev.name,
        type: 'line',
        yAxisIndex: 0, // 使用的 y 轴的 index，在单个图表实例中存在多个 y轴的时候有用
        smooth: true, // 平滑曲线显示
        showAllSymbol: true, // 显示所有图形。
        symbol: 'circle', // 标记的图形为实心圆
        symbolSize: 6, // 标记的大小
        itemStyle: {
          // 折线拐点标志的样式
          color: '#058cff'
        },
        lineStyle: {
          color: '#058cff'
        },
        // areaStyle: {
        //   color: 'rgba(5,140,255, 0.2)'
        // },
        data: prev.list
      },

      {
        name: next.name,
        type: 'line',
        yAxisIndex: 1, // 使用的 y 轴的 index，在单个图表实例中存在多个 y轴的时候有用
        smooth: true, // 平滑曲线显示
        showAllSymbol: true, // 显示所有图形。
        symbol: 'circle', // 标记的图形为实心圆
        symbolSize: 6, // 标记的大小
        itemStyle: {
          // 折线拐点标志的样式
          color: '#1ab01c'
        },
        lineStyle: {
          color: '#1ab01c'
        },
        // areaStyle: {
        //   color: 'rgba(26, 176, 28, 0.2)'
        // },
        data: next.list
      }
    ]
  }
}
